import { useQuery } from '@tanstack/react-query';
import { maintenanceContainer } from '../../di/container';

export function useBlockConfig(enabled: boolean) {
  return useQuery({
    queryKey: ['maintenance', 'block-config'],
    queryFn: () => maintenanceContainer.repository.getBlockConfig(),
    enabled,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
}
